var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9041819JumpRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 21,
    viewBox: "0 0 21 21",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(5.5 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 8v-2c0-1.65685425 1.34314575-3 3-3h8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.999 6 3.001-3-3.001-3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9041819JumpRightIcon);
export default __webpack_public_path__ + "static/media/9041819_jump_right_icon.f41a2ae43e64ea345a0ef05aaa5cd0af.svg";
export { ForwardRef as ReactComponent };